export default __webpack_public_path__ + "static/media/NI-GT2002.64a0d2d0.jpg";